import React from 'react';
import { motion } from 'framer-motion';
import { FileText, MessageSquare, GraduationCap, Calendar, Repeat, HeartHandshake } from 'lucide-react';
const features = [{
  icon: FileText,
  title: 'Build Logs',
  description: "Document every bolt, every setback, and every victory. Your project's history, preserved."
}, {
  icon: MessageSquare,
  title: 'Forums',
  description: 'Real discussions. Technical deep dives. No algorithm chasing, just community.'
}, {
  icon: GraduationCap,
  title: 'Knowledge Base',
  description: 'Crowdsourced wisdom from people who have actually done the work.'
}, {
  icon: Calendar,
  title: 'Events',
  description: 'Local meets, garage nights, and online hangouts. Find your local crew.'
}, {
  icon: Repeat,
  title: 'Parts Swap',
  description: 'Peer-to-peer marketplace. Trade parts, tools, and favors. No fees.'
}, {
  icon: HeartHandshake,
  title: 'Mentorship',
  description: 'Connect with veterans who can guide you through your first engine rebuild.'
}];
export function Features() {
  return <section className="py-24 bg-garage-surface relative" data-id="element-32">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-garage-border to-transparent" data-id="element-33" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-34">
        <div className="mb-16" data-id="element-35">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-garage-text mb-4" data-id="element-36">
            YOUR GARAGE. <span className="text-garage-accent" data-id="element-37">YOUR RULES.</span>
          </h2>
          <p className="text-garage-muted text-lg max-w-2xl" data-id="element-38">
            Everything you need to build your dream car and connect with people
            who get it.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-39">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} whileHover={{
          y: -5
        }} className="bg-garage-bg p-6 border border-garage-border hover:border-garage-accent transition-all duration-300 group cursor-default" data-id="element-40">
              <div className="flex items-start gap-4" data-id="element-41">
                <div className="p-3 bg-garage-card rounded-sm border border-garage-border group-hover:border-garage-accent/50 transition-colors" data-id="element-42">
                  <feature.icon className="w-6 h-6 text-garage-muted group-hover:text-garage-accent transition-colors" data-id="element-43" />
                </div>
                <div data-id="element-44">
                  <h3 className="text-xl font-display font-bold text-garage-text mb-2 group-hover:text-garage-accent transition-colors" data-id="element-45">
                    {feature.title}
                  </h3>
                  <p className="text-garage-muted text-sm leading-relaxed" data-id="element-46">
                    {feature.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}